import { registerFeatureMessages, type SupportedLocale } from '@/shared/i18n'

export function registerScorecardMessages(locale: SupportedLocale): Promise<void> {
  return registerFeatureMessages('scorecards', locale)
}
